export default __webpack_public_path__ + "static/media/pic3.9c5b7196.jpg";